
(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusControllers')
        .controller('InitiativeUpdateStatusEligibleForAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessPlanningService', 'notificationService', 'historyCtxtService', 'eligibleOwnersForAssessment'];

    function Controller($scope, $state, topBarService, businessPlanningService, notificationService, historyCtxtService, eligibleOwnersForAssessment) {
        topBarService.setTitleAndIcon('Business Planning - Initiatives Eligible for Assessment', 'fa fa-compass');

        $scope.eligibleOwnersForAssessment = eligibleOwnersForAssessment;
        $scope.showNoInitiativeSelected = false;
        var isCreatingAssessments = false;

        // Split data in 2 columns for display
        var nbItemsPerCol = Math.ceil($scope.eligibleOwnersForAssessment.length / 2);
        $scope.firstColOwners = $scope.eligibleOwnersForAssessment.slice(0, nbItemsPerCol);
        $scope.secondColOwners = $scope.eligibleOwnersForAssessment.slice(nbItemsPerCol);

        // Toggle All Initiatives for Owner
        $scope.toggleAllInitiativesForOwner = function (ownerWithInitiatives) {
            _.each(ownerWithInitiatives.PlanInitiativesList, function (planInitiative) {
                planInitiative._isSelected = ownerWithInitiatives._allInitiativesSelected;
            });

            if (ownerWithInitiatives._allInitiativesSelected) {
                $scope.showNoInitiativeSelected = false;
            }
        };

        // Select All Initiatives
        $scope.selectAllInitiatives = function () {
            _.each($scope.eligibleOwnersForAssessment, function (ownerWithInitiatives) {

                _.each(ownerWithInitiatives.PlanInitiativesList, function (planInitiative) {
                    planInitiative._isSelected = true;
                });

                ownerWithInitiatives._allInitiativesSelected = true;
            });

            $scope.showNoInitiativeSelected = false;
        };

        // Clear Selection
        $scope.clearSelection = function () {
            _.each($scope.eligibleOwnersForAssessment, function (ownerWithInitiatives) {

                _.each(ownerWithInitiatives.PlanInitiativesList, function (planInitiative) {
                    planInitiative._isSelected = false;
                });

                ownerWithInitiatives._allInitiativesSelected = false;
            });
        };

        // Create Assessments
        $scope.createAssessments = function () {
            if (isCreatingAssessments) return;

            var initiativeIds = [];
            isCreatingAssessments = true;

            _.each($scope.eligibleOwnersForAssessment, function (ownerWithInitiatives) {

                _.each(ownerWithInitiatives.PlanInitiativesList, function (planInitiative) {
                    if (planInitiative._isSelected) {
                        initiativeIds.push(planInitiative.PlanInitiativeID);
                    }
                });
            });

            if (initiativeIds.length === 0) {
                isCreatingAssessments = false;
                $scope.showNoInitiativeSelected = true;
            } else {
                businessPlanningService
                    .createAssessmentsForPlanInitiatives(initiativeIds)
                    .then(function () {
                        notificationService
                            .notify(initiativeIds.length
                                + ' new Initiative'
                                + (initiativeIds.length === 1 ? '' : 's')
                                + ' ready for tracking');

                        $state.go('initiativeUpdateStatusOwnerList');
                    })
                    .finally(function () {
                        isCreatingAssessments = false;
                    });
            }
        };

        // Go To Initiative
        $scope.goToInitiative = function (initiative) {
          historyCtxtService.goToStateWithOptions('initiative.edit', {
          toStateParams: {InitiativeID: initiative.PlanInitiativeID},
          ctxStateName: $state.current.name,
          ctxtBreadcrumbTitle: 'Eligible For Assessment',
          ctxtBreadcrumbIcon: ''
        });
        };

        // Go to Init. Update Status Owner list
        $scope.goToOwnersAndStatus = function () {
            $state.go('initiativeUpdateStatusOwnerList');
        };

    }
})();
